// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"30d6c1f1","455":"191d9ac1"}[chunkId] + ".chunk.js";
};